module.exports = {
    "items": {
        "json": "http://jser.info/source-data/items.json"
    },
    "posts": {
        "json": "http://jser.info/posts.json"
    }
};